import { useMemo } from 'react';

import { useTabContentConfig } from '../../../next/CustomDash/components/PageConfigProvider/PageConfigProvider';
import { UserPreferenceKey } from '../types';
import { preferenceAdapters } from '../utils/preference-filter-adapters';

export function useCustomDashPreferenceVisibility() {
  const { hasFilter } = useTabContentConfig();

  return useMemo(() => {
    return (key: UserPreferenceKey): boolean => {
      if (key === UserPreferenceKey.Geography) {
        return true;
      }
      if (key === UserPreferenceKey.PageOrder) {
        return true;
      }
      if (key === UserPreferenceKey.ColorMode) {
        return true;
      }
      if (key === UserPreferenceKey.Taxonomies) {
        return true;
      }
      // Only the economic-impact page's own preferences button offers these;
      // they have no filter on any CustomDash page to be relevant to.
      if (
        key === UserPreferenceKey.EconomicImpactIndustries ||
        key === UserPreferenceKey.EconomicImpactGeography
      ) {
        return false;
      }
      // Default Filters are edited per scope via the modal's scope switcher, so
      // they show regardless of which primary filter the current page has.
      if (key === UserPreferenceKey.DefaultFilters) {
        return true;
      }
      const related = preferenceAdapters[key]?.relevantFilters ?? [];
      if (related.length === 0) return true;
      return related.every((filterId) => hasFilter(filterId));
    };
  }, [hasFilter]);
}
